export const API_PATH_ApiCreateCompanyPost = '/services/auth-create-company';
